import React, {Component} from 'react';

import './Checkbox.css';

// initially unchecked. set props.selected=true for initially checked
// set props.label for text next to the checkbox, props.name to name the input
export default class Checkbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected:  props.selected ? props.selected : false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getCheck = this.getCheck.bind(this);
  }

  handleInputChange(event) {
    this.setState({
      selected: event.target.checked
    });
    if (this.props?.parentData)
      this.props.parentData(event.target.checked, this.props?.index ?? 0);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected)
      this.setState({selected: this.props.selected});
  }

  getCheck() {
    return this.state.selected;
  }

  checkboxOnly () {
    return (
      <input name={this.props?.name ?? "inputname"}
          type="checkbox"
          checked={this.state.selected}
          onChange={this.handleInputChange}
          disabled={this.props.disabled ?? false}
      />
    )
  }
  render() {
    if (this.props?.label)
      return (<label>{this.checkboxOnly()} {this.props.label}</label>)
    else
      return this.checkboxOnly();
  }
}

export function initCheckboxen(count) {
  let blanks = [];
  blanks.length = count;
  return blanks.fill(false);
}
export function checkedObjects(objs, checks){
  return Array.isArray(objs) ? objs.filter((item, index) => (checks[index])) : []
}

